// Permission names grouped by area, with Lao labels, for the role permission editor.
// A permission the backend has but this file does not list still shows, under "ອື່ນໆ",
// with its raw name — so a new backend permission is never hidden.
export const PERMISSION_GROUPS = [
  {
    key: 'dashboard',
    label: 'ໜ້າຫຼັກ ແລະ ແຈ້ງເຕືອນ',
    icon: 'mdi-view-dashboard',
    permissions: {
      get_dashboard: 'ເບິ່ງໜ້າ Dashboard',
      get_activity: 'ເບິ່ງປະຫວັດການໃຊ້ງານລະບົບ',
      noti: 'ຈັດການແຈ້ງເຕືອນລູກຄ້າ',
    },
  },
  {
    key: 'reports',
    label: 'ລາຍງານ',
    icon: 'mdi-file-chart-outline',
    permissions: {
      report: 'ເບິ່ງທຸກລາຍງານ',
      report_finance: 'ລາຍງານບິນ ແລະ ການເງິນ',
      report_ar: 'ລາຍງານໜີ້ຄ້າງ (AR)',
      report_customer: 'ລາຍງານລູກຄ້າ',
      report_field: 'ລາຍງານພາກສະໜາມ',
      report_bank: 'ລາຍງານທະນາຄານ',
      report_com_activity: 'ລາຍງານເຄື່ອນໄຫວລູກຄ້າທຸລະກິດ',
      report_home_activity: 'ລາຍງານເຄື່ອນໄຫວລູກຄ້າສາຍບ້ານ (ແລະ Export Excel)',
    },
  },
  {
    key: 'users',
    label: 'ຜູ້ໃຊ້ ແລະ ສິດ',
    icon: 'mdi-account-key',
    permissions: {
      get_user: 'ເບິ່ງຜູ້ໃຊ້',
      create_user: 'ເພີ່ມຜູ້ໃຊ້',
      update_user: 'ແກ້ໄຂຜູ້ໃຊ້',
      delete_user: 'ລຶບຜູ້ໃຊ້',
      reset_password: 'ຣີເຊັດລະຫັດຜ່ານ',
      get_role: 'ເບິ່ງ Role',
      create_role: 'ເພີ່ມ Role',
      update_role: 'ແກ້ໄຂ Role',
      delete_role: 'ລຶບ Role',
      manage_role_permission: 'ກຳນົດ Permission ໃຫ້ Role',
      manage_user_permission: 'ກຳນົດ Permission ໃຫ້ຜູ້ໃຊ້',
      manage_user_role: 'ກຳນົດ Role ໃຫ້ຜູ້ໃຊ້',
    },
  },
  {
    key: 'customers',
    label: 'ລູກຄ້າ',
    icon: 'mdi-account-group',
    permissions: {
      get_customer: 'ເບິ່ງລູກຄ້າທຸກປະເພດ',
      get_customer_home: 'ເບິ່ງລູກຄ້າຄົວເຮືອນ',
      get_customer_company: 'ເບິ່ງລູກຄ້າທຸລະກິດ',
      get_customer_event: 'ເບິ່ງລູກຄ້າເກັບຂີ້ເຫຍື້ອພິເສດ',
      create_customer: 'ເພີ່ມລູກຄ້າ',
      update_customer: 'ແກ້ໄຂລູກຄ້າ',
      delete_customer: 'ລຶບລູກຄ້າ',
    },
  },
  {
    key: 'company',
    label: 'ລູກຄ້າທຸລະກິດ (ຜ່ານການອະນຸມັດ)',
    icon: 'mdi-domain',
    permissions: {
      create_com: 'ສົ່ງຄຳຂໍເພີ່ມລູກຄ້າທຸລະກິດ',
      approve_com: 'ອະນຸມັດການເພີ່ມລູກຄ້າທຸລະກິດ',
      edit_com: 'ສົ່ງຄຳຂໍແກ້ໄຂລູກຄ້າທຸລະກິດ',
      approve_edit_com: 'ອະນຸມັດການແກ້ໄຂລູກຄ້າທຸລະກິດ',
      convert_home_com: 'ສົ່ງຄຳຂໍປິດສາຍບ້ານເປີດທຸລະກິດ',
      approve_convert_home_com: 'ອະນຸມັດປິດສາຍບ້ານເປີດທຸລະກິດ',
      request_delete_bill_com: 'ສົ່ງຄຳຂໍລຶບບິນລູກຄ້າທຸລະກິດ',
      approve_delete_bill_com: 'ອະນຸມັດການລຶບບິນລູກຄ້າທຸລະກິດ',
    },
  },
  {
    key: 'homeDelete',
    label: 'ລຶບລູກຄ້າສາຍບ້ານ (ອະນຸມັດ 3 ຂັ້ນ)',
    icon: 'mdi-account-remove-outline',
    permissions: {
      request_delete_home: 'ສົ່ງຄຳຂໍລຶບລູກຄ້າສາຍບ້ານ (ແລະ Import Excel)',
      approve_delete_home_1: 'ອະນຸມັດລຶບລູກຄ້າສາຍບ້ານ ຂັ້ນທີ 1',
      approve_delete_home_2: 'ອະນຸມັດລຶບລູກຄ້າສາຍບ້ານ ຂັ້ນທີ 2',
      approve_delete_home_3: 'ອະນຸມັດລຶບລູກຄ້າສາຍບ້ານ ຂັ້ນທີ 3 (ລຶບຈິງ)',
    },
  },
  {
    key: 'homeBillDelete',
    label: 'ລຶບບິນສາຍບ້ານ (ອະນຸມັດ 3 ຂັ້ນ)',
    icon: 'mdi-file-document-remove-outline',
    permissions: {
      request_delete_bill_home: 'ສົ່ງຄຳຂໍລຶບບິນສາຍບ້ານ (ແລະ Import Excel)',
      approve_delete_bill_home_1: 'ອະນຸມັດລຶບບິນສາຍບ້ານ ຂັ້ນທີ 1',
      approve_delete_bill_home_2: 'ອະນຸມັດລຶບບິນສາຍບ້ານ ຂັ້ນທີ 2',
      approve_delete_bill_home_3: 'ອະນຸມັດລຶບບິນສາຍບ້ານ ຂັ້ນທີ 3 (ລຶບຈິງ)',
    },
  },
  {
    key: 'homeStatus',
    label: 'ປິດ/ເປີດສາຍບ້ານ (ອະນຸມັດ 3 ຂັ້ນ)',
    icon: 'mdi-swap-horizontal-circle-outline',
    permissions: {
      request_status_home: 'ສົ່ງຄຳຂໍປິດ/ເປີດສາຍບ້ານ: active/inactive (ແລະ Import Excel)',
      approve_status_home_1: 'ອະນຸມັດປິດ/ເປີດສາຍບ້ານ ຂັ້ນທີ 1',
      approve_status_home_2: 'ອະນຸມັດປິດ/ເປີດສາຍບ້ານ ຂັ້ນທີ 2',
      approve_status_home_3: 'ອະນຸມັດປິດ/ເປີດສາຍບ້ານ ຂັ້ນທີ 3 (ປ່ຽນຈິງ)',
    },
  },
  {
    key: 'staff',
    label: 'ພະນັກງານ, ຄົນຂັບ ແລະ ທີມ',
    icon: 'mdi-account-hard-hat',
    permissions: {
      get_employee: 'ເບິ່ງພະນັກງານ',
      create_employee: 'ເພີ່ມພະນັກງານ',
      update_employee: 'ແກ້ໄຂພະນັກງານ',
      delete_employee: 'ລຶບພະນັກງານ',
      get_driver: 'ເບິ່ງຄົນຂັບ',
      create_driver: 'ເພີ່ມຄົນຂັບ',
      update_driver: 'ແກ້ໄຂຄົນຂັບ',
      delete_driver: 'ລຶບຄົນຂັບ',
      get_team: 'ເບິ່ງທີມ',
      create_team: 'ເພີ່ມທີມ',
      update_team: 'ແກ້ໄຂທີມ',
      delete_team: 'ລຶບທີມ',
      get_team_member: 'ເບິ່ງສະມາຊິກທີມ',
      create_team_member: 'ເພີ່ມສະມາຊິກທີມ',
      update_team_member: 'ແກ້ໄຂສະມາຊິກທີມ',
      delete_team_member: 'ລຶບສະມາຊິກທີມ',
    },
  },
  {
    key: 'vehicles',
    label: 'ລົດ ແລະ ປະເພດລົດ',
    icon: 'mdi-truck',
    permissions: {
      get_vehicle: 'ເບິ່ງລົດ',
      create_vehicle: 'ເພີ່ມລົດ',
      update_vehicle: 'ແກ້ໄຂລົດ',
      delete_vehicle: 'ລຶບລົດ',
      get_vehicle_type: 'ເບິ່ງປະເພດລົດ',
      create_vehicle_type: 'ເພີ່ມປະເພດລົດ',
      update_vehicle_type: 'ແກ້ໄຂປະເພດລົດ',
      delete_vehicle_type: 'ລຶບປະເພດລົດ',
    },
  },
  {
    key: 'villages',
    label: 'ບ້ານ',
    icon: 'mdi-home-group',
    permissions: {
      create_village: 'ເພີ່ມບ້ານ',
      update_village: 'ແກ້ໄຂບ້ານ',
      delete_village: 'ລຶບບ້ານ',
    },
  },
  {
    key: 'packages',
    label: 'ແພັກເກດ ແລະ ລາຄາ',
    icon: 'mdi-tag',
    permissions: {
      create_package: 'ເພີ່ມແພັກເກດ',
      update_package: 'ແກ້ໄຂແພັກເກດ',
      delete_package: 'ລຶບແພັກເກດ',
      setting_price: 'ຕັ້ງຄ່າລາຄາ',
    },
  },
  {
    key: 'routes',
    label: 'ແຜນເສັ້ນທາງ ແລະ ການເກັບຂີ້ເຫຍື້ອ',
    icon: 'mdi-map-marker-path',
    permissions: {
      get_route_plan: 'ເບິ່ງແຜນເສັ້ນທາງ',
      create_route_plan: 'ສ້າງແຜນເສັ້ນທາງ',
      update_route_plan: 'ແກ້ໄຂແຜນເສັ້ນທາງ',
      update_route_plan_map: 'ແກ້ໄຂແຜນທີ່ເສັ້ນທາງ',
      delete_route_plan: 'ລຶບແຜນເສັ້ນທາງ',
      get_plan_calendar: 'ເບິ່ງປະຕິທິນແຜນ',
      create_plan_calendar: 'ສ້າງປະຕິທິນແຜນ',
      update_plan_calendar: 'ແກ້ໄຂປະຕິທິນແຜນ',
      delete_plan_calendar: 'ລຶບປະຕິທິນແຜນ',
      collect_trash: 'ບັນທຶກການເກັບຂີ້ເຫຍື້ອ',
      confirm_trash: 'ຢືນຢັນການເກັບຂີ້ເຫຍື້ອ',
    },
  },
  {
    key: 'events',
    label: 'ເກັບຂີ້ເຫຍື້ອພິເສດ (Event)',
    icon: 'mdi-calendar-star',
    permissions: {
      get_event: 'ເບິ່ງ Event',
      request_event: 'ຂໍເກັບຂີ້ເຫຍື້ອພິເສດ',
      manage_event: 'ຈັດການ Event',
    },
  },
  {
    key: 'billing',
    label: 'ບິນ ແລະ ການຊຳລະເງິນ',
    icon: 'mdi-receipt',
    permissions: {
      get_invoice: 'ເບິ່ງບິນ',
      create_invoice: 'ສ້າງບິນຢ້ອນຫຼັງ ແລະ ບິນລ່ວງໜ້າ',
      update_invoice: 'ແກ້ໄຂບິນ',
      approve_invoice: 'ອະນຸມັດບິນ',
      pay_any_invoice: 'ຊຳລະບິນຂອງລູກຄ້າໃດກໍໄດ້',
      confirm_payment: 'ຢືນຢັນການຊຳລະ',
      reject_payment: 'ປະຕິເສດການຊຳລະ',
    },
  },
  {
    key: 'eod',
    label: 'ປິດບັນຊີປະຈຳວັນ (EOD)',
    icon: 'mdi-bank-check',
    permissions: {
      'eod-ldb-reconciliation': 'ກະທົບຍອດ LDB',
      'eod-approve-close-finance': 'ອະນຸມັດປິດບັນຊີ (ການເງິນ)',
      'eod-approve-close-it': 'ອະນຸມັດປິດບັນຊີ (IT)',
    },
  },
  {
    key: 'danger',
    label: 'ລຶບຂໍ້ມູນທັງໝົດ (ລະວັງ)',
    icon: 'mdi-alert',
    danger: true,
    permissions: {
      delete_any_bills: 'ລຶບບິນໃດກໍໄດ້',
      delete_any_customers: 'ລຶບລູກຄ້າໃດກໍໄດ້',
    },
  },
];

const LABELS = PERMISSION_GROUPS.reduce(
  (all, group) => Object.assign(all, group.permissions),
  {},
);

export function permissionLabel(name) {
  return LABELS[name] || name;
}

// Groups (in catalog order) holding only the permission names the server returned;
// names the catalog does not know go into a trailing "ອື່ນໆ" group.
export function groupPermissions(names) {
  const available = new Set(names);
  const groups = PERMISSION_GROUPS
    .map((group) => ({
      ...group,
      items: Object.keys(group.permissions)
        .filter((name) => available.has(name))
        .map((name) => ({ name, label: group.permissions[name] })),
    }))
    .filter((group) => group.items.length);
  const unknown = names.filter((name) => !LABELS[name]).sort();
  if (unknown.length) {
    groups.push({
      key: 'other',
      label: 'ອື່ນໆ',
      icon: 'mdi-dots-horizontal',
      items: unknown.map((name) => ({ name, label: name })),
    });
  }
  return groups;
}

// Roles of customers: the backend refuses permission and role changes for them
// (and for users holding one of them).
export const CUSTOMER_ROLES = ['pre_customer', 'customer', 'company'];

// Per catalog group: how many of its permissions `names` holds (groups with none are left
// out); names the catalog does not know are counted under "ອື່ນໆ".
export function summarizePermissions(names) {
  const summary = PERMISSION_GROUPS.map((group) => {
    const all = Object.keys(group.permissions);
    return {
      key: group.key,
      label: group.label,
      icon: group.icon,
      danger: group.danger,
      total: all.length,
      count: all.filter((name) => names.includes(name)).length,
    };
  }).filter((group) => group.count);
  const other = names.filter((name) => !LABELS[name]).length;
  if (other) {
    summary.push({
      key: 'other', label: 'ອື່ນໆ', icon: 'mdi-dots-horizontal', total: other, count: other,
    });
  }
  return summary;
}
